var scope_0 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/381955a489c06a28ea072a7004286fe6.js').default;
var scope_1 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/389bfb32e57feeef1269cc4a5a8bba78.js').default;
var scope_2 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3ed36cf28bd26874acf55af9b3451d85.js').default;
var scope_3 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/68b6880fe2acba7671413091e84290b4.js').default;
var scope_4 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7180b66beeac2c715896f09a2dfa5242.js').default;
var scope_5 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/84ac5c3469d513b92439a514b0d49124.js').default;
var scope_6 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/89eae5089c41870626d1f23caec3dedb.js').default;
var scope_7 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dace892c7319150aba53283f33c4f220.js').default;
var scope_8 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_9 = require('/opt/build/repo/packages/forma-36-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fdd850d643de2782142fbbacbd24e82c.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9 )
    